module.exports = __webpack_public_path__ + "img/newBox_right.eb652317.png";